export default "__VITE_ASSET__BvoIIfHz__"